import { Container } from "@mui/material";
import React from "react";
import Footer from "../Footer/Footer";
import classes from "../Inspiration/Inspiration.module.css";
import LandingPageNav from "../LandingPage/LandingPageNav";

const Inspiration = () => {
  return (
    <>
      <LandingPageNav />
      <Container>
        <div className={classes.head}>
          <h2>Inspiration</h2>
          <p>
            If you are looking for inspiration on how you can use our platform
            to solve problems, then read on. We will continue to add more
            inspirational stories here.
          </p>
        </div>
        <div className={classes.faq}>
          <h3>Frequently Asked Question</h3>
          <h4>What is journey Analytics platform ?</h4>
          <div className={classes.faqContent}>
            <p>
              Journey Analytics platform enables tracking major transitions of
              stakeholders in easy to analyze format. Instead of investing in
              costly infrastructure to implement data analytics you can leverage
              Cloud technologies to connect data from multiple systems and
              generate insights quickly. Our platform is designed to support
              variety of Journeys. Following is a sample list of journeys we are
              starting to support.
            </p>
            <div className={classes.faqList}>
              <ul>
                <li>B2B Customer Journeys</li>
                <li>Employee Journeys</li>
                <li>Partner Journeys</li>
                <li>Vendor Journeys</li>
                <li>High Touch Sales Journeys across industries</li>

                <ul>
                  <li>Construction</li>
                  <li>Real Estate</li>
                  <li>Legal</li>
                </ul>
              </ul>
            </div>
            <div>
              <h4>Why do I need Analytics ?</h4>
              <p>
                Whether you are a sole proprietor, owner of small medium
                business or executive responsible for a business function in a
                large organization, everyone is always looking for the
                following.
              </p>
              <div className={classes.faq2List}>
                <ul>
                  <li>What is working ?</li>
                  <li>What is not working? How do I change that?</li>
                  <li>
                    What action I take to take my organization to the next
                    level?
                  </li>
                </ul>
              </div>
              <p>
                Answers to these questions do not come easily. Data can be your
                friend, guide, and mentor. Data is the only asset that does not
                diminish in value when you use it. And you have data that can
                help but you are struggling to get value of the data.
              </p>
            </div>
            <div>
              <h4>
                I understand data can help me, but I don’t have time and money
                to run analytics. What can I do?
              </h4>
              <div className={classes.faq3List}>
                <ul>
                  <li>A platform to host the data</li>
                  <li>Tools to help you visualize the data</li>
                  <li>A little help from experts to setup</li>
                  <li>Training to use the data the right way</li>
                </ul>
              </div>
            </div>
            <div>
              <h4>When will I get return on investment from analytics?</h4>
              <p>
                There is no fixed formula on how quickly you will get value for
                your investment. Sometimes it can take a few weeks to realize
                value. It depends on volume data (historical and current) on
                what reliable insights you can get. Data needs to reach a
                statistical significance before you can start relying on data.
              </p>
            </div>
            <div>
              <h4>What is statistical significance?</h4>
              <p>
                One of the main objectives with analytics is to see a pattern
                that gives you confidence that your decision is right.
              </p>
              <p>
                Imagine you are reviewing restaurant reviews. You see a rating
                of 5/5 and 3.5/5. Your initial reaction will be to go to the
                restaurant with higher rating. But when you check closely you
                can see the number of reviews is different for each restaurant.
                5/5 (1 review) vs 3.5/5 (10000 reviews). There is enough data in
                this case to trust the data.
              </p>
            </div>
           <div className={classes.faqMiddle}   >
           <div className={classes.faqMiddle1} >
              <h4>
                I get it now, how much will it cost me to implement Journey
                Analytics Platform?
              </h4>
              <p>
                Don’t consider analytics implementation as a cost. It is
                investment to help you get better. Our goal is to provide an
                affordable platform based on your needs. Our experts (or
                partners) can guide you through what you can expect based on
                your specific needs.
              </p>
            </div>
            <div className={classes.faqMiddle1}>
              <h4>
                What kind of data do you help analyze? I don’t have lot of data.
              </h4>
              <p>
                Common datasets that are analyzed will be from Cloud platforms
                and excel sheets. We will guide you on how to implement systems
                that will help you capture data that tracks your day-to-day
                interactions before implementing analytics.
              </p>
            </div>
           </div>
            <div className={classes.faqLast}>
              <h4>Can you give more examples of problems you will solve?</h4>
              <p>
                Analytics help you answer the questions that are keeping you
                awake. Questions vary based on your business but following are a
                few common questions.
              </p>
              <div className={classes.faq3List}>
                <ul>
                  <li>
                    How many leads/prospects do I have now for my business?
                  </li>
                  <li>
                    How is my business performance this year compared to last
                    year?
                  </li>
                  <li>Is this going to be my best year yet?</li>
                  <li>
                    Which business function do I need to invest in to reach my
                    business goals for this year?
                  </li>
                  <li>How do I know I am on target to meet goals?</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer/>
    </>
  );
};

export default Inspiration;
